import { isBoolean, isString } from "lodash";
import { AbstractDate } from "@linkfluence/models/date";
import { Timezone } from "@linkfluence/models/timezone";
import { mmt } from "@tootools/date";
import { ClauseBuilder } from "./builder";
import { getFieldFromInnerClause } from "./getter";
import { Clause, InnerClause } from "./model";

export function refineClauseWithoutClause(
  clause: Clause,
  excludedClause: Clause
) {
  const builder = ClauseBuilder.create(clause);
  builder.removeClause(excludedClause);
  return builder.toClause();
}

export function refineClauseWithInnerClause(
  clause: Clause,
  innerClause: InnerClause,
  replace?: boolean
) {
  const builder = ClauseBuilder.create(clause);
  if (!isBoolean(replace) || replace) {
    builder.removeField(getFieldFromInnerClause(innerClause));
  }
  builder.addInnerClause(innerClause);
  return builder.toClause();
}

export function refineClauseWithDate(
  clause: Clause,
  date: { from: AbstractDate; to: AbstractDate; tz?: Timezone }
) {
  return refineClauseWithInnerClause(clause, {
    date: {
      from: isString(date.from) ? date.from : mmt(date.from).toISOString(),
      to: isString(date.to) ? date.to : mmt(date.to).toISOString(),
      ...(date?.tz ? { tz: date?.tz } : {}),
    },
  });
}

export function refineClauseWithoutField(clause: Clause, field: string) {
  const builder = ClauseBuilder.create(clause);
  builder.removeField(field);
  return builder.toClause();
}

export function refineClauseWithoutFields(clause: Clause, fields: string[]) {
  const builder = ClauseBuilder.create(clause);
  fields.forEach((field) => builder.removeField(field));
  return builder.toClause();
}

export function refineClauseWithoutDate(clause: Clause) {
  return refineClauseWithoutField(clause, "date");
}

export function refineClauseWithoutQuery(clause: Clause) {
  return refineClauseWithoutField(clause, "query");
}
